module.exports = __webpack_public_path__ + "static/media/bus-eirann.7b43d1a1.png";